'use client';
import * as React from 'react';
import { useCountiesByZipLazyQuery } from '../documents';


const useIsSpecificState = (state: string) => (zip?: string) => {
  const [request, { data }] = useCountiesByZipLazyQuery();

  const result = React.useMemo(() => {
    return data?.plans_zip_county_fips[0].state;
  }, [data]);

  React.useEffect(() => {
    if (zip) {
      request({ variables: { zip } });
    }
  }, [zip]);

  return result ? result === state : undefined;
};

export const useIsMAState = useIsSpecificState('MA');
export const useIsWIState = useIsSpecificState('WI');
